import { getRevenueCenterMenuUuids } from 'utils/menusDrawer/getRevenueCenterMenuUuids'

// return boolean: true when at least one his children is checked
export const getIsIndeterminateState = (
  uuid,
  filteredMenusAndRevenueCenters,
  selectedRevenueCentersAndMenusUuids
) => {
  // uuids of menus assigned to revenue center
  const revenueCenterMenusUuids = getRevenueCenterMenuUuids(
    filteredMenusAndRevenueCenters,
    uuid
  )

  if (
    // return false when all revenueCenterMenusUuids are inluded in selectedRevenueCentersAndMenusUuids
    revenueCenterMenusUuids?.every((uuid) =>
      selectedRevenueCentersAndMenusUuids?.includes(uuid)
    )
  ) {
    return false
  } else if (
    // return true when at least one revenueCenterMenusUuid is included in selectedRevenueCentersAndMenusUuids
    revenueCenterMenusUuids?.some((uuid) =>
      selectedRevenueCentersAndMenusUuids?.includes(uuid)
    )
  ) {
    return true
  } else {
    return false
  }
}
